import React, { useEffect, useState } from 'react';
import { getConfig } from '../config';
import { PublicSearchResult } from '../services/api';
import { useContent } from '../contexts/ContentContext';
import ContentPageHeader from './PageHeader';

export default function RatingGuide({ embedded = false }: { embedded?: boolean }) {
    const Entry = embedded ? 'div' : 'a';
    const { content, language, t } = useContent();
    const [result, setResult] = useState<Pick<PublicSearchResult, 'ratings' | 'unrated_count'> | null>(null);
    const [error, setError] = useState('');
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        const controller = new AbortController();
        setError(''); setResult(null);
        fetch(`${getConfig().apiHost.replace(/\/+$/, '')}/get_index.php?type=ratings`, { signal: controller.signal })
            .then(response => { if (!response.ok) throw new Error('http'); return response.json(); })
            .then(data => {
                if (!Array.isArray(data.ratings) || !Number.isInteger(data.unrated_count) || data.unrated_count < 0
                    || data.ratings.some((rating: any) => !rating || !Number.isInteger(rating.value) || rating.value < 1 || rating.value > 5 || !Number.isInteger(rating.count) || rating.count < 0)) throw new Error('invalid');
                if (!controller.signal.aborted) setResult(data);
            }).catch(err => { if (!controller.signal.aborted) setError(err.message); });
        return () => controller.abort();
    }, [attempt]);
    return <section className="lab-content-page dark:text-gray-100 ivory:text-coffee-800">
        {embedded ? <p className="mb-6">{t('searchRatingGuide.text2')}</p> : <ContentPageHeader title={t('searchRatingGuide.text1')} description={t('searchRatingGuide.text2')} />}
        <ul className="space-y-3">{content.ui[language].search.ratingMeanings.map((meaning, index) => <li key={index}>
            <Entry className="block rounded-lg border bg-white p-4 dark:bg-gray-800 ivory:bg-coffee-50" href={embedded ? undefined : `/?page=search&rating=${index + 1}`}>
                <strong className="mr-3">★{index + 1}</strong>{meaning}
                {result && <span className="ml-3 text-sm">({t('search.count', { count: result.ratings.find(rating => rating.value === index + 1)?.count || 0 })})</span>}
            </Entry>
        </li>)}</ul>
        {error && <div role="alert" className="mt-4"><p>{t('search.error')}</p><button className="lab-button" onClick={() => setAttempt(value => value + 1)}>{t('common.retry')}</button></div>}
        {!error && !result && <p role="status" className="mt-4">{t('searchRatingGuide.text4')}</p>}
        <p className="mt-6">{t('searchRatingGuide.text5')}</p>
        {result && <p className="mt-3">{t('search.unrated', { count: result.unrated_count })}</p>}
    </section>;
}
